import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const HelpsRoute = [
    {
        path: '/helps',
        component: React.lazy(() => import('./Helps.js')),
        auth: AuthRoles.editor,
    }
]

export default HelpsRoute;